import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ContributionData } from "src/store/Goal-Based/goal";
import moment from "moment";
import { UpdateFieldPayload } from "./goal";

const DEFAULT_PERIOD_MONTHS = 12;

const initialState: ContributionData = {
  /**
   * A year, and an end date that agrees with it.
   *
   * The period was 12 months and the end date was start + FIVE — two
   * contradictory statements of the same span in one initial state. It did
   * not show, because the duration field recomputes the end date from the
   * period and dispatches it; but that happens as the field renders, and
   * the stats query fires from the form ABOVE it, so the very first
   * projection of every session went out asking for a twelve-month plan
   * ending in five months' time. Derived from the period now, so the two
   * cannot drift apart again.
   */
  period: DEFAULT_PERIOD_MONTHS,
  start_date: moment().format("YYYY-MM-DDTHH:mm:ss.SSSSSS"),
  end_date: moment()
    .add(DEFAULT_PERIOD_MONTHS, "month")
    .format("YYYY-MM-DDTHH:mm:ss.SSSSSS"),
  contribution_type: 1,
  initial_amount: "0",
  contribution_amount: "500",
  objective: "retirementLumpSum",
};

const ContributionAmountSlice = createSlice({
  name: "contributionAmount",
  initialState,
  reducers: {
    updateContributionField: (
      state: any,
      action: PayloadAction<UpdateFieldPayload<ContributionData>>,
    ) => {
      const { name, value } = action.payload;
      state[name] = value;
    },
  },
});

export const { updateContributionField } = ContributionAmountSlice.actions;
export default ContributionAmountSlice.reducer;
